import { useEffect, useState } from "react";
import { useTranslation } from 'react-i18next';

// Utility to get current locale from cookie
const getLocale = () => {
  const match = document.cookie.match(/(^|;)\s*locale=([^;]*)/);
  return match ? decodeURIComponent(match[2]) : "en";
};

// Custom hook to fetch localized Strapi data
const useFetchStrapiData = (collection) => {
  const [data, setData] = useState([]);
  const locale = getLocale();

  const STRAPI_URL = process.env.REACT_APP_STRAPI_URL || "http://localhost:1337";
  const STRAPI_TOKEN = process.env.REACT_APP_STRAPI_TOKEN;

  const path = `/api/${collection}?populate=*&locale=${locale}`;
  const url = STRAPI_URL ? new URL(STRAPI_URL + path) : null;

  useEffect(() => {
    if (!url || !STRAPI_TOKEN) return;

    const fetchData = async () => {
      try {
        const response = await fetch(url, {
          headers: {
            Authorization: `Bearer ${STRAPI_TOKEN}`,
            "Content-Type": "application/json",
          },
        });

        const result = await response.json();
        setData(result.data);
      } catch (err) {
        console.error("❌ Fetch error:", err.message);
      }
    };

    fetchData();
  }, [url, STRAPI_TOKEN]);

  return { data };
};

const PageTitle = () => {
  const { t } = useTranslation();
  const { data } = useFetchStrapiData("home");

  // Assuming your Strapi "home" collection has "title" and "subtitle" fields
  const title = data?.attributes?.title || t("recipes.defaultTitle", "Recipes");
  const subtitle = data?.attributes?.subtitle || t("recipes.defaultSubtitle", "A collection of personal recipes rooted in tradition and curiosity");

  return (
	 <div className="container mt-5 mt-xl-10">
      <div className="row g-3 g-xl-5 align-items-end">
        <div className="col-lg-12">
          <h1 style={{ lineHeight: '80%' }}>
			<span className="display-2 text-black" style={{ fontWeight: 'bold', lineHeight: '50%' }}>{t("recipes.title", "Recipes")}</ span>
	  		{subtitle && ( <span className="display-4 text-black" style={{ lineHeight: '50%' }}><br />{t("recipes.subTitle", "A collection of personal recipes rooted in tradition and curiosity")}</ span> )}
	  	  </h1>
        </div>
      </div>
    </div>
  );
};

export default PageTitle;
